import liff from '@line/liff'

let messages = '';

document.addEventListener('DOMContentLoaded', function() {
	liff.init({
		liffId: window.ENV_LIFF_ID
	}).then(() => {
		// LIFF is ready
		console.log('LIFF initialization completed');
		document.getElementById("shareButton")?.addEventListener("click", (event) => {
			messages = event.target.dataset.pdfUrl
			handleLoginAndShare();
		});
	}).catch((error) => {
		console.error('LIFF initialization failed', error);
	});
});

function handleLoginAndShare() {
	if (!liff.isLoggedIn()) {
		liff.login({ redirectUri: window.location.href });
	} else {
		shareMessage();
	}
}

function shareMessage() {
	liff.shareTargetPicker([
		{
			type: "text",
			text: messages
		}
	]).then((result) => {
		if (result) {
			console.log("Message shared successfully");
		} else {
			console.log("ShareTargetPicker was closed before sharing");
		}
	}).catch((error) => {
		console.error("Error sharing message", error);
	});
}
